import { generateClassName } from '@klv/shared/utils/functions';
import KlaviyoCertificate from '@klv/shared/search/KlaviyoCertificate.png';

import * as s from '@klv/molecules/unified-search-result-grid-item/styles/unified-search-result-grid-item.module.css';

export const CertificateBadge = ({ hasCertificateBadge = false }) => {
  return hasCertificateBadge ? (
    <div className={generateClassName([s.badge])}>
      <img
        src={KlaviyoCertificate?.src ?? KlaviyoCertificate} // this is needed to work with astro
        alt=''
      />
    </div>
  ) : null;
};
